import standardAPI from '@/api/standard_items';

const state = {
  team_categories: [],
  team_categories_status: '',
  team_categories_MetaData: {},
  team_categories_page: 1,
  team_categories_perPage: 10,
};

const responseUrl = '/team/categories';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_team_categories ({ commit }, getOptions) {
    commit('TEAM_CATEGORIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        if (response) {
          commit('TEAM_CATEGORIES_SUCCESS', response);
          commit('TEAM_CATEGORIES_READY');
          resolve(response);
        } else {
          commit('TEAM_CATEGORIES_ERROR');
          reject(response);
        }
      }, preparedOptions);
    });
  },
  add_team_category ({ commit, dispatch }, itemData) {
    commit('TEAM_CATEGORIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('TEAM_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  edit_team_category ({ commit, dispatch }, itemData) {
    commit('TEAM_CATEGORIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('TEAM_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  remove_team_category ({ commit, dispatch }, itemData) {
    commit('TEAM_CATEGORIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('TEAM_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.team_categories_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.team_categories_perPage = max;
  },
  TEAM_CATEGORIES_READY: (state) => {
    state.team_categories_status = 'ready';
  },
  TEAM_CATEGORIES_REQUEST: (state) => {
    state.team_categories_status = 'loading';
  },
  TEAM_CATEGORIES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.team_categories_MetaData.meta = response.meta;
      state.team_categories_MetaData.links = response.links;
    }
    state.team_categories = response.data;
    state.team_categories_status = 'success';
  },
  TEAM_CATEGORIES_ERROR: (state) => {
    state.team_categories_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
